export default "__VITE_ASSET__3mdmba9P__"